@if (hasProfileSet) {
  <div>
    <router-outlet></router-outlet>
  </div>
}
